import { Card, Grid, Icon, IconButton, InputLabel } from "@mui/material";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDModal from "components/MDModal";
import MDTypography from "components/MDTypography";
import { useUser } from "context/UserContext";
import DataTable from 'examples/Tables/DataTable';
import { Form, Formik } from "formik";
import DefaultCell from "layouts/dashboards/sales/components/DefaultCell";
import PropTypes from "prop-types";
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { toDateTime } from "utils/DateUtils";
import { post } from 'utils/WebService';

const ChildProcess = ({ id, onViewProcessMain }) => {

  const [data, setData] = useState([]);
  const [pages, setPages] = useState(0);
  const [loadingTable, setLoadingTable] = useState(true);
  const [recordsTotal, setRecordsTotal] = useState(0);
  const [aplicar, setAplicar] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [dados, setDados] = useState(null);
  const [header, setHeader] = useState(null);

  const { statusCasoProcessual, sistemasEnum } = useUser();

  const tableState = useRef({
    pageSize: 10,
    pageIndex: 0,
    sorting: [],
    filtered: [],
    numeroProcesso: null
  });

  useEffect(() => {
    if (id) {
      fetchChildProcess({ ...tableState.current });
    }
  }, []);

  const columns = [
    {
      header: "processo",
      accessorKey: "processo",
      cell: info => <DefaultCell>{info.getValue() || ""}</DefaultCell>,
      isSorted: true
    },
    {
      header: "parte contrária",
      accessorKey: "parteContraria",
      cell: info => <DefaultCell>{info.getValue() || ""}</DefaultCell>,
      isSorted: true
    },
    {
      header: "cliente",
      accessorKey: "cliente.nomeComum",
      cell: info => <DefaultCell>{info.getValue() || ""}</DefaultCell>,
      isSorted: true
    },
    {
      header: "status",
      accessorKey: "status",
      cell: info => {
        const status = statusCasoProcessual?.find(ht => ht.code === info.getValue());
        return <DefaultCell>{status ? status.name : "-"}</DefaultCell>;
      },
      isSorted: true
    },
    {
      header: "Processo eletrônico",
      accessorKey: "processoEletronico",
      cell: info => {
        const processo = sistemasEnum?.find(ht => ht.code === info.getValue());
        return <DefaultCell>{processo ? processo.name : "-"}</DefaultCell>;
      },
      isSorted: true,
      width: "9%"
    },
    {
      header: "Dias s/ movimentações",
      accessorKey: "diasSemMovimentacao",
      cell: info => <DefaultCell>{`${info.getValue() || ""}`}</DefaultCell>,
      isSorted: true,
      width: "10%"
    },
    {
      header: "última atualização",
      accessorKey: "ultimaAtualizacao",
      cell: info => <DefaultCell>{toDateTime(info.getValue()) || '-'}</DefaultCell>,
      isSorted: true
    },
    {
      header: "próxima atualização",
      accessorKey: "proximaExecucao",
      cell: info => <DefaultCell>{toDateTime(info.getValue()) || '-'}</DefaultCell>,
      isSorted: true
    },
    {
      header: "Mensagem",
      accessorKey: "mensagem",
      cell: info => (
        info.getValue()?.length > 0 && (
          <IconButton onClick={() => handleOpenModal(info.getValue(), 'Mensagem')}>
            <MDTypography variant="h4">
              <Icon color="inherit" sx={{ mr: 1 }}>description</Icon>
            </MDTypography>
          </IconButton>
        )
      ),
      isSorted: true,
      width: "7%"
    },
    {
      header: "ações",
      accessorKey: "visualizar",
      isSorted: false,
      cell: info => (
        <IconButton onClick={() => onViewProcessMain(info.row.original?.id, true)}>
          <MDTypography variant="h4">
            <Icon color="inherit" sx={{ mr: 1 }}>visibility</Icon>
          </MDTypography>
        </IconButton>
      ),
      width: "8%"
    },
  ];

  const handleOpenModal = (dados, header) => {
    setDados(dados);
    setHeader(header);
    setIsModal(true);
  };

  const handleCloseModal = () => {
    setIsModal(false);
    setDados(null);
    setHeader(null);
  };

  const fetchChildProcess = useCallback(({ pageSize, pageIndex, sorting, numeroProcesso }) => {

    setLoadingTable(true);

    const updatedTableState = {
      pageSize: pageSize ? pageSize : tableState.current.pageSize,
      pageIndex: (pageIndex == 0 || pageIndex) ? pageIndex : tableState.current.pageIndex,
      sorting: sorting ? sorting : tableState.current.sorting,
      numeroProcesso: numeroProcesso,
    };

    tableState.current = updatedTableState;

    const body = {
      page: updatedTableState.pageIndex,
      pageSize: updatedTableState.pageSize,
      sorted: updatedTableState.sorting,
      filtered: updatedTableState.filtered,
      idProcessoPai: id,
      numeroProcesso: updatedTableState.numeroProcesso,
    };

    post("/processo/list", body)
      .then(({ data, pages, recordsTotal }) => {
        setPages(pages);
        setData(data);
        setRecordsTotal(recordsTotal);
        setLoadingTable(false);
        setAplicar(false);
      }).catch(() => {
        setLoadingTable(false)
        setAplicar(false);
      });
  }, []);

  const handleApplyFilter = (values) => {
    fetchChildProcess({
      ...tableState.current, pageIndex: 0, numeroProcesso: values.numeroProcesso,
    });
  };

  const handleCleanFilter = () => {
    setData([]);

    const updatedTableState = {
      pageSize: 10,
      pageIndex: 0,
      sorting: [],
      filtered: [],
      numeroProcesso: "",
    };

    tableState.current = updatedTableState;

    fetchChildProcess(updatedTableState);
  };
  return (
    <Card id="child-process">
      {isModal &&
        <MDModal
          header={header}
          dados={dados}
          show={isModal}
          close={handleCloseModal}
        />
      }

      <Grid item xs={12} md={12}>
        <MDBox p={2}>
          <Formik
            initialValues={{
              numeroProcesso: ''
            }}
            onSubmit={(values) => handleApplyFilter(values)}>
            {({ values, setFieldValue, resetForm }) => {
              return (
                <Form>
                  <Grid container spacing={2} pt={2}>
                    <Grid item xs={12} sm={3}>
                      <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>N° Processo</InputLabel>
                       <MDInput
                        size="small"
                        fullWidth
                        placeholder="Informe o nº do processo"
                        value={values.numeroProcesso}
                        onChange={(e) => setFieldValue('numeroProcesso', e.target.value)}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} display='flex' justifyContent='space-between'>
                      <Grid item xs={12} sm={12} textAlign="right">
                        <MDButton
                          size="medium"
                          sx={{ marginRight: 2 }}
                          variant="contained"
                          color="info"
                          circular={false}
                          iconOnly={false}
                          onClick={() => {
                            resetForm();
                            handleCleanFilter();
                          }}
                        >
                          Limpar filtro
                        </MDButton>
                        <MDButton
                          size="medium"
                          variant="contained"
                          color="info"
                          circular={false}
                          iconOnly={false}
                          type="submit"
                        >
                          Aplicar filtro
                        </MDButton>
                      </Grid>
                    </Grid>
                  </Grid>
                </Form>
              )
            }}
          </Formik>
        </MDBox>

        <MDBox p={2}>
          <DataTable
            loading={loadingTable}
            columnData={columns}
            data={data}
            fetchData={fetchChildProcess}
            totalPages={pages}
            totalRecords={recordsTotal}
            changeFilter={aplicar}
            tableState={tableState} />
        </MDBox>
      </Grid>
    </Card>
  );
};

ChildProcess.propTypes = {
  id: PropTypes.string,
};

export default memo(ChildProcess);
